import { Component } from '@angular/core';

@Component({
  selector: 'app-setting-market',
  templateUrl: './setting-market.component.html',
  styleUrls: ['./setting-market.component.scss']
})
export class SettingMarketComponent {

}
